<template>
    <div style="background: #F6F6F6;">
        <van-pull-refresh v-model="isProductLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
        <div class="audithome_wrap" id="firstloan_head">
            <div class="audithome_head">
                <div class="audithome_hleft">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                    </div>
                    <div class="audithome_hrimg">
                        <!--<img src="../../assets/img/audithome_icon02.png" />-->
                    </div>
                </div>
            </div>
            <div class="audithome_tps" style="display: flex; justify-content: flex-start;">
                <div class="audithome_tps_text"> El orden será inválido hasta</div>
                <div class="auditpass_times" style="padding-top: 0;">

                    <van-count-down :time="time" :format="format">
                        <template #default="timeData">
                            <div class="zpan_hthr_times">
                                <div class="zpan_hthr_titmes">
                                    <span>{{ timeData.days }}</span>
                                </div>
                                <div class="zpan_hthr_ditmes_day">days</div>
                                <div class="zpan_hthr_titmes">
                                    <span>{{ timeData.hours }}</span>
                                </div>
                                <div class="zpan_hthr_ditmes">:</div>
                                <div class="zpan_hthr_titmes">
                                    <span>{{ timeData.minutes }}</span>
                                </div>
                                <div class="zpan_hthr_ditmes">:</div>
                                <div class="zpan_hthr_titmes">
                                    <span>{{ timeData.seconds }}</span>
                                </div>
                            </div>
                        </template>
                    </van-count-down>
                </div>
            </div>
        </div>

        <div id="firstloan">
            <div class="audithome_cont" :class="calculationInfo ? 'audithome_cont_height' : '' ">
                <div class="audithome_cview">
                    <div class="auditpass_wrap">
                        <div class="mobhome_onewrap">
                            <div class="mobhome_twoview">
                                <div class="mobhome_tview">
                                    <!--<div class="kychome_slider_title">Monto del préstamo</div>-->
                                    <div class="eshoy_slider_cont mobhome_tview_slider">
                                        <div class="firstloan_amount">
                                            <div class="firstloan_amount_left">
                                                <div class="firstloan_amount_title">Monto de préstamo</div>
                                                <div class="loan-content-box" @click="onStepShow">
                                                    <div class="moneybox" style="text-align: left; display: flex; justify-content: flex-start; align-items: center; padding: 9px 0 0 0;">
                                                        <div>$</div>
                                                        <div>
                                                            <span id="money">
                                                            <template v-if="products">
                                                                <template v-if="stepAmount">
                                                                    {{ dealNumber(stepAmount) }}
                                                                </template>
                                                                <template v-else>
                                                                    {{ dealNumber(products.aft_hws_cuj) }}
                                                                </template>
                                                            </template>
                                                            <template v-else>0</template>
                                                            </span>
                                                        </div>
                                                        <div style="display: flex; align-items: center;">
                                                            <van-icon name="arrow" size="24"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="firstloan_amount_right">
                                                <div class="firstloan_amount_title">Plazo</div>
                                                <div class="firstloan_amount_days">
                                                    <span><template v-if="products">{{ products.uyo_mbc_sie }}</template>
                                                    <template v-else>0</template></span> días</div>
                                            </div>
                                        </div>

                                        <div class="confirmloan_cmview confirmloan_cmview_repeat" >
                                            <div class="itoken_check_vitems" @click="onShowLoanDays">
                                                <div class="itoken_check_vitem">
                                                    <div class="itoken_check_vitop">
                                                        <div class="itoken_check_vitleft_coupon">
                                                            <span style="font-size: 0.388889rem">Días de plazo préstamo</span>
                                                        </div>
                                                        <div class="itoken_check_vitright">
                                                            <div class="itoken_check_vitrnums" style="font-weight: 400">{{ radioDays }} días</div>
                                                            <div class="itoken_check_vitrarrow">
                                                                <template v-if="showLoanDetail">
                                                                    <img src="../../assets/img/trialOneCclose_arrowup.webp" alt="" />
                                                                </template>
                                                                <template v-else>
                                                                    <img src="../../assets/img/trialOneCclose_arrowdown.webp" alt="" />
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="eshoy_slider_btns">
                                            <div class="eshoy_slider_btn_view" @click="onHomeConfirm">
                                                <van-button color="linear-gradient(to top, #0F9F52, #2DDD7F)" block style="height: 1.111111rem; border-radius: 8px;">
                                                    <span style="font-weight: 500;">Applyling for a loan</span>
                                                </van-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mobhome_twoview" style="margin-top: 10px;" v-if="calculationInfo">
                                <template v-if="calculationInfo">
                                    <div class="firstloan_loantitle">Detalles del préstamo</div>
                                    <div class="confirmloan_cmview">
                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Monto de Préstamo</div>
                                            <div class="confirmloan_cmiright">${{ calculationInfo.myi_hop_pek }}</div>
                                        </div>

                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Plazo</div>
                                            <div class="confirmloan_cmiright"
                                            >{{ calculationInfo.sas_dsz_vuf }} Días</div
                                            >
                                        </div>

                                        <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                            <div class="confirmloan_cmileft">Fecha de Pago</div>
                                            <div class="confirmloan_cmiright">{{ calculationInfo.luc_nhd_dmo }}</div>
                                        </div>

                                        <div class="itoken_check_vitems" @click="onShowLoanDetail" :class="showLoanDetail ? '' : 'itoken_checkvi_scale-1px'">
                                            <div class="itoken_check_vitem">
                                                <div class="itoken_check_vitop">
                                                    <div class="itoken_check_vitleft_coupon">
                                                        <span style="font-size: 0.388889rem">Monto a Pagar</span>
                                                    </div>
                                                    <div class="itoken_check_vitright">
                                                        <div class="itoken_check_vitrnums" style="font-weight: 400"></div>
                                                        <div class="itoken_check_vitrarrow">
                                                            <template v-if="showLoanDetail">
                                                                <img src="../../assets/img/trialOneCclose_arrowup.webp" alt="" />
                                                            </template>
                                                            <template v-else>
                                                                <img src="../../assets/img/trialOneCclose_arrowdown.webp" alt="" />
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="itoken_check_vitems_details" v-if="showLoanDetail">
                                            <div class="itoken_check_vitems_detail">
                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Principal</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.mhv_cjz_hgv }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Interés</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.kmi_eve_gzt }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">IVA</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.hkf_frh_klx }}</span></div
                                                    >
                                                </div>

                                                <div class="confirmloan_msgitems">
                                                    <div class="confirmloan_msgileft">Cobro de Servicio</div>
                                                    <div class="confirmloan_msgiright"
                                                    >$<span>{{ calculationInfo.qij_wyk_ywo }}</span></div
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="auditcommon_cont">
            <!--<div class="auditcommon_one">
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon01.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon02.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon03.png" />
                </div>
                <div class="auditcommon_oitem">
                    <img src="../../assets/img/homefooter_icon06.png" />
                </div>
            </div>-->
            <div class="auditcommon_two"></div>
            <div class="auditcommon_thr" style="margin-bottom: 50px;">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>


            <van-popup v-model="loanDaysShow" position="bottom" round>
                <div class="verifycode_wrap">
                    <div class="verifycode_cont">
                        <div class="verifycode_tilte"></div>
                        <div class="verifycode_top verifycode_coupons_top">
                            <div class="verifycode_tleft">
                            <span>
                                Plan de reembolso
                            </span>
                            </div>
                            <div class="verifycode_tright" @click="loanDaysShow = false">
                                <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                            </div>
                        </div>

                        <div class="coupons_form">
                            <div class="coupons_list">
                                <van-radio-group v-model="radioDays" @change="onRadioChange">
                                    <van-cell-group>
                                        <template v-for="(item, index) in daysList">
                                            <div class="coupons_items" :key="item.uyo_mbc_sie" :class="index == daysList.length - 1 ? 'coupons_items_end' :''">
                                                <div class="coupons_item" :class="item.uyo_mbc_sie == radioDays ? 'coupons_active' : ''">
                                                    <van-cell clickable @click="onProduct(item)">
                                                        <template #title>
                                                            <div class="coupons_ileft">
                                                                <div class="coupons_ilname">{{item.uyo_mbc_sie}} días</div>
                                                                <div class="coupons_ildesc">Fecha de reembolso：{{item.paytime}}</div>
                                                            </div>
                                                        </template>

                                                        <template #right-icon>
                                                            <div class="coupons_iright">
                                                                <div class="coupons_irview">
                                                                    <van-radio :name="item.uyo_mbc_sie" >
                                                                        <template #icon="props">
                                                                            <img v-if="props.checked" src="@/assets/mobimg/radio_ischeck.png" alt="">
                                                                            <img v-else src="@/assets/mobimg/radio_nocheck.png" alt="">
                                                                        </template>
                                                                    </van-radio>
                                                                </div>
                                                            </div>
                                                        </template>

                                                    </van-cell>
                                                </div>
                                            </div>
                                        </template>
                                    </van-cell-group>
                                </van-radio-group>
                            </div>
                        </div>

                        <div class="verifycode_footer_btns">
                            <div class="verifycode_footer_btn">
                                <van-button round color="#00CA88" block @click="onDaysConfirm">
                                    <span style="font-weight: bold; font-size: 16px;">Enterado</span>
                                </van-button>
                            </div>
                        </div>

                    </div>
                </div>
            </van-popup>

            <van-popup v-model="stepAmountShow" position="bottom" round>
                <div class="verifycode_wrap">
                    <div class="verifycode_cont">
                        <div class="verifycode_tilte"></div>
                        <div class="verifycode_top verifycode_coupons_top">
                            <div class="verifycode_tleft">
                            <span>
                                Importe opcional
                            </span>
                            </div>
                            <div class="verifycode_tright" @click="stepAmountShow = false">
                                <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                            </div>
                        </div>

                        <div class="coupons_form">
                            <div class="coupons_list">
                                <van-radio-group v-model="radioStep" @change="onStepChange">
                                    <van-cell-group>
                                        <template v-for="(item, index) in stepList">
                                            <div class="coupons_items" :key="item.uyo_mbc_sie" :class="index == stepList.length - 1 ? 'coupons_items_end' :''">
                                                <div class="coupons_item" :class="item == radioStep ? 'coupons_active' : ''">
                                                    <van-cell clickable @click="onStep(item)">
                                                        <template #title>
                                                            <div class="coupons_ileft">
                                                                <div class="coupons_ilname" style="padding: 6px 0 0 0;">{{item}} pesos</div>
                                                            </div>
                                                        </template>

                                                        <template #right-icon>
                                                            <div class="coupons_iright">
                                                                <div class="coupons_irview">
                                                                    <van-radio :name="item" >
                                                                        <template #icon="props">
                                                                            <img v-if="props.checked" src="@/assets/mobimg/radio_ischeck.png" alt="">
                                                                            <img v-else src="@/assets/mobimg/radio_nocheck.png" alt="">
                                                                        </template>
                                                                    </van-radio>
                                                                </div>
                                                            </div>
                                                        </template>

                                                    </van-cell>
                                                </div>
                                            </div>
                                        </template>
                                    </van-cell-group>
                                </van-radio-group>
                            </div>
                        </div>

                        <div class="verifycode_footer_btns">
                            <div class="verifycode_footer_btn">
                                <van-button round color="#00CA88" block @click="onStepConfirm">
                                    <span style="font-weight: bold; font-size: 16px;">Confirmación</span>
                                </van-button>
                            </div>
                        </div>

                    </div>
                </div>
            </van-popup>


        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
        </van-pull-refresh>
    </div>
</template>

<script type="text/javascript">

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { parseTime, getNextDate } from '@/utils/index'
    import { getAccessToken } from '@/utils/auth';

    import { getAccountInfo } from '@/api/apply';
    import { getLoanInfo, getProductinfo, createOrder, calculationTrial, confirmOrder, confirmLoan } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';
    let apiHead = '';

    export default{
        data() {
            return {
                isFalse: false,
                isTrue: true,
                tabactive: 0,
                changeNum: 50,
                sliderValue: 50,
                time: null,
                format: 'HH:mm:ss',
                showLoanDetail: false,
                amount: 0,
                period: 0,
                isProductLoading: false,
                productInfo: null,
                calculationInfo: null,
                loanAmount: 0,
                loanDays: 0,
                payTimes: null,
                bankCode: null,
                couponsList: [],
                couponsObj: null,
                payAmount: 0,
                interest_fee: 0, //利息
                fee: 0, //服务费
                vat: 0,
                shouPay: 0,
                origin_contract_amount: 0,
                coupon_type: 0,
                daysList: [],
                stepList: [],
                loanDaysShow: false,
                stepAmountShow: false,
                products: null,
                daysCheck: null,
                radioDays: 0,
                radioStep: 0,
                stepAmount: 0,
                time_zone: null,
                ip: null,
            }

        },
        mounted() {
            this.countDown();
            this.gotoStatus();
        },
        methods: {
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/firstloan'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            onShowLoanDetail() {
                this.showLoanDetail = !this.showLoanDetail;
            },
            onHomeConfirm() {

                this.onConfirmLoan();

               /* let calculationInfo = this.calculationInfo;
                if(calculationInfo){

                } else {
                    Toast('请先试算');
                    Toast('Por favor, haga clic en el cálculo de prueba primero.')
                }*/
            },
            onStepShow() {
                this.stepAmountShow = true;
            },
            onCloseMeuns() {
                this.menusShow = false;
            },
            onHomeMenus() {
                this.menusShow = true;
            },
            countDown() { // 传入时间戳
                const d = new Date('2025-07-16').getTime()
                if(d && d != 0){
                    const now = new Date().getTime();
                    let timeStamp = d - now;

                    console.log(timeStamp)
                    this.time = timeStamp;
                }
            },
            dealNumber(num) {
                if (num != 0 && num) {
                    num = num + "";
                    let splitList = num.split(".");
                    //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
                    let intStrList = splitList[0]
                        .split("")
                        .reverse()
                        .join("")
                        .match(/(\d{1,3})/g);
                    //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
                    let intStr = intStrList.join(",").split("").reverse().join("");
                    return intStr;
                }
                return num;
            },
            onShowLoanDays() {
                this.loanDaysShow = true;
            },
            onRadioChange(e){

            },
            onStepChange(e){

            },
            onDaysConfirm(){
                this.products = null;
                this.radioStep = 0;
                this.stepAmount = 0;
                let usedaysCheck = this.daysCheck;
                console.log(usedaysCheck)
                this.radioDays = usedaysCheck.uyo_mbc_sie;
                this.products = usedaysCheck;
                this.loanDaysShow = false;

                this.calculationInfo = null;
                let time_zone = this.time_zone;
                let ip = this.ip;
                this.getCalculationTrial(time_zone, ip, usedaysCheck);
            },
            onStepConfirm() {
                this.stepAmountShow = false;
                let radioStep = this.radioStep;
                console.log(radioStep)
                this.calculationInfo = null;
                let time_zone = this.time_zone;
                let ip = this.ip;
                let productsInfo = this.products;
                this.getCalculationTrial(time_zone, ip, productsInfo);
            },
            onProduct(data){ //选择产品
                this.daysCheck = data;
                this.radioDays = data.uyo_mbc_sie;
            },
            onStep(data) { //选择金额
                this.radioStep = data;
            },
            onRefresh() {
                this.isProductLoading = true;
                this.gotoStatus();
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        this.isProductLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;

                                if(vkt_fnd_yzo){
                                    let { hxo_gjz_xif, nen_cog_yim, nlb_phe_yac, lks_dol_bul, pri_jrg_ucv, hkf_frh_klx, luc_nhd_dmo } = vkt_fnd_yzo;

                                    console.log('bank_no:' + hxo_gjz_xif)
                                    console.log('loan_amount' + nen_cog_yim)
                                    console.log('loan_term' + nlb_phe_yac)
                                    console.log('repay_interest' + lks_dol_bul)
                                    console.log('service_fee' + pri_jrg_ucv)
                                    console.log('vat' + hkf_frh_klx)
                                    console.log('repay_time' + luc_nhd_dmo)

                                    let totalAmount = Number(nen_cog_yim) + Number(lks_dol_bul) + Number(pri_jrg_ucv) + Number(hkf_frh_klx);

                                    _this.amount = nen_cog_yim;
                                    _this.period = nlb_phe_yac;
                                    _this.loanAmount = nen_cog_yim;
                                    _this.loanDays = nlb_phe_yac;
                                    _this.bankCode = hxo_gjz_xif;
                                    _this.payTimes = luc_nhd_dmo;
                                    _this.payAmount = totalAmount;
                                    _this.interest_fee = lks_dol_bul;
                                    _this.fee = pri_jrg_ucv;
                                    _this.vat = hkf_frh_klx;

                                    // bank_no hxo_gjz_xif
                                    // vat hkf_frh_klx
                                    // loan_amount nen_cog_yim
                                    // service_fee pri_jrg_ucv
                                    // repay_interest lks_dol_bul
                                    // repay_time luc_nhd_dmo
                                    // loan_term nlb_phe_yac


                                    //order_status, reapply_time, current_is_reloan,
                                    let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl,  } = vkt_fnd_yzo;

                                    console.log(omi_fje_qly);
                                    console.log(huw_kdq_nxo);
                                    console.log(ojq_dzg_oxq);
                                    console.log(xhi_cur_ovl);

                                    //               order_status, reapply_time, server_time, current_is_reloan,
                                    //this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);


                                    let product_suitable = [];
                                    let { dts_uvj_plp } = vkt_fnd_yzo;

                                    /*let dts_uvj_plp = [
                                        {
                                            "uyo_mbc_sie": 8,
                                            "mir_env_pfp": 200,
                                            "hqi_nqu_zsz": 2013078303100007110,
                                            "nnd_xdd_kbd": 1,
                                            "aft_hws_cuj": 200,
                                            "kad_xdn_wkn": "2013078303100007110",
                                            "gvy_hlf_shs": 8
                                        },
                                        {
                                            "uyo_mbc_sie": 9,
                                            "mir_env_pfp": 500,
                                            "hqi_nqu_zsz": 2013078303100007111,
                                            "nnd_xdd_kbd": 1,
                                            "aft_hws_cuj": 500,
                                            "kad_xdn_wkn": "2013078303100007111",
                                            "gvy_hlf_shs": 9
                                        },
                                        {
                                            "uyo_mbc_sie": 15,
                                            "mir_env_pfp": 900,
                                            "hqi_nqu_zsz": 2013078303100007112,
                                            "nnd_xdd_kbd": 1,
                                            "aft_hws_cuj": 900,
                                            "kad_xdn_wkn": "2013078303100007112",
                                            "gvy_hlf_shs": 15
                                        },
                                    ];*/

                                    if(dts_uvj_plp && dts_uvj_plp.length > 0){
                                        product_suitable = dts_uvj_plp;
                                        for(let i=0; i<product_suitable.length; i++){
                                            let nowTime = new Date().getTime();

                                            let nowDate = parseTime(nowTime, '{y}-{m}-{d}'); //获取当前时间
                                            let useDate = getNextDate(nowDate, product_suitable[i].uyo_mbc_sie, "{d}/{m}/{y}");

                                            product_suitable[i].paytime = useDate;
                                            console.log(useDate)
                                        }

                                        product_suitable.sort((a,b) => {return b.uyo_mbc_sie - a.uyo_mbc_sie});

                                        console.log(product_suitable)

                                        product_suitable[0].normal_amount = Number(product_suitable[0].aft_hws_cuj);

                                        _this.products = product_suitable[0];
                                        _this.daysCheck = product_suitable[0];
                                        _this.radioDays = product_suitable[0].uyo_mbc_sie;

                                        _this.stepList = _this.setAmountList(product_suitable[0].mir_env_pfp, product_suitable[0].aft_hws_cuj)

                                        _this.getCalculationTrial(time_zone, ip, product_suitable[0]);
                                    } else {
                                        loadingHide()
                                    }

                                    _this.daysList = product_suitable;

                                }
                            }
                        } else {
                            loadingHide()
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isProductLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            setAmountList: (min, max) => {
                let result = [];
                for (let i = min; i <= max; i++) {
                    result.push(i);
                }
                result = result.filter(num => num % 50 === 0);
                console.log(result);
                return result;
            },
            getCalculationTrial(time_zone, ip, productInfo){
                console.log('--------productInfo--------');
                console.log(productInfo)
                this.time_zone = time_zone;
                this.ip = ip;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    let radioStep = this.radioStep;

                    let loanAmount = 0;
                    if(radioStep){
                        loanAmount = String(radioStep);
                        this.stepAmount = loanAmount;
                    } else {
                        loanAmount = String(productInfo.aft_hws_cuj)
                    }

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        llg_pys_mii: '1',
                        lck_olj_vmv: loanAmount,
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.kad_xdn_wkn,
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    calculationTrial(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    this.calculationInfo = useDataJSON;
                                    this.stepList = this.setAmountList(productInfo.mir_env_pfp, productInfo.aft_hws_cuj);
                                    // 本金 loan lck_olj_vmv
                                    // 利息 interest_fee kmi_eve_gzt
                                    // 税费 vat hkf_frh_klx
                                    // 服务费 fee qij_wyk_ywo

                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async getProductListApi() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getProductinfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isProductLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);

                                let { dts_uvj_plp } = useDataJSON;
                                if(dts_uvj_plp && dts_uvj_plp.length){
                                    this.productInfo = dts_uvj_plp[0];
                                    console.log(dts_uvj_plp[0])
                                    this.amount = dts_uvj_plp[0].mir_env_pfp;
                                    this.period = dts_uvj_plp[0].uyo_mbc_sie;
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isProductLoading = false;
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            onGotoLoan() {
                let productInfo = this.productInfo;
                this.getCalculationTrial(productInfo);
            },

            async onConfirmLoan(){
                let _this = this;
                //this.confirmShow = true;
                    const login_token = getAccessToken();
                    console.log(login_token)
                    if(login_token){ //已经登录
                        console.log('已登录11111')
                        let time_zone = getTimezoneName();
                        console.log(time_zone);
                        loadingShow();
                        let ip = await getUserIp()
                        console.log(ip)

                        let loanAmount = this.loanAmount;
                        let loanDays = this.loanDays;

                        let productId = this.$store.state.common.productId;
                        let products = this.products;

                        let stepAmount = this.stepAmount;

                        let setloanAmount = 0;

                        if(stepAmount && stepAmount > 0){
                            setloanAmount = stepAmount;
                        } else {
                            setloanAmount = products.aft_hws_cuj;
                        }

                        let postData = {
                            zzm_yya_hqb: getAccessToken(),
                            lck_olj_vmv: String(setloanAmount),
                            bpb_imu_jqa: '',
                            sas_dsz_vuf: String(products.uyo_mbc_sie),
                            oti_fmd_qms: products.kad_xdn_wkn,
                            nen_cog_yim: String(setloanAmount),
                            jba_hmp_qjh: String(setloanAmount),
                            aaa_off_csl: '111',
                        };

                        let headerParams = {
                            'ad-justad-id': localStorage.getItem("adjust_id"),
                            'ad-justad-j': '',
                            'ad-justad-idfv': '',
                        };

                        loadingShow();
                        confirmLoan(postData, {
                            'bwd-irh-lnf': time_zone,
                            'xfo-plp-van': ip,
                            ...headerParams
                        }).then(res => {
                            console.log(res)
                            loadingHide()
                            if(res.ci == 200){
                                let useData = res.da;
                                console.log(JSON.parse(useData))
                                if(useData){
                                    let useDataJSON = JSON.parse(useData);
                                    if(useDataJSON){
                                        _this.$router.replace({
                                            path: '/loanpage/loanstatus'
                                        });
                                    }
                                }
                            } else {
                                Toast(res.ms);
                            }
                        }, error => {
                            loadingHide()
                        });
                    } else { //未登录
                        this.$router.replace({
                            path: '/loanpage/loginhome'
                        })
                    }
            },
            onCheckTokenKey() {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.onConfirmOrder(tokenKey);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);

                            _this.onConfirmOrder(r);
                        });
                    }, 10);
                }
            },
            async onConfirmOrder(tokenKey) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let productInfo = this.productInfo;

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        vjk_fjt_bvh: tokenKey,
                        lck_olj_vmv: String(productInfo.mir_env_pfp),
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.id_str,
                        bpb_imu_jqa: '',
                        fkc_cmc_zbn: '',
                        doe_ody_zty: '',
                        // lck_olj_vmv: '200',
                        // sas_dsz_vuf: '7',
                        // oti_fmd_qms: '2013078303100007002',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    confirmOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    _this.$store.commit('common/SET_PRODUCT_ID', productInfo.id_str);
                                    _this.$router.replace({
                                        path: '/loanpage/loanstatus'
                                    });
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async onCreateOrder(productInfo) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        llg_pys_mii: '1',
                        lck_olj_vmv: String(productInfo.mir_env_pfp),
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.id_str,
                        // lck_olj_vmv: '200',
                        // sas_dsz_vuf: '7',
                        // oti_fmd_qms: '2013078303100007002',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    createOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        //loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){

                                    _this.getCalculationTrial(productInfo);
                                    //this.calculationInfo = useDataJSON;

                                    // 本金 loan lck_olj_vmv
                                    // 利息 interest_fee kmi_eve_gzt
                                    // 税费 vat hkf_frh_klx
                                    // 服务费 fee qij_wyk_ywo

                                }
                            } else {
                                loadingHide()
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
        }
    }

</script>

<style scss scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
       /* background: rgba(255,255,255,0.26);*/
        margin-top: 6px;
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    #firstloan{
        /*padding-bottom: 30px;*/
    }
    #firstloan .audithome_cont{
        width: 100%;
        height: 1.0rem;
        position: relative;
    }
    #firstloan .audithome_cont_height{
        height: 4.1rem;
    }
    #firstloan  .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #firstloan  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0.416667rem;
    }
    .auditcommon_one{
        width: 100%;
        height: 3.638889rem;
    }
    .auditcommon_oitem{
        width: 50%;
        height: 2.083333rem;
        float: left;
    }
    .auditcommon_oitem img{
        display: block;
        width: 100%;
        height: 2.083333rem;
    }
    .auditcommon_two{
        width: 100%;
        height: auto;
        border-radius: 6px;
        margin: 0.416667rem 0;
        overflow: hidden;
    }
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    .mobhome_onewrap{
        width: 100%;
        height: auto;
    }
    .mobhome_twoview{
        width: 91.11%;
        height: auto;
        margin: 0 auto;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0.277778rem;
        border-radius: 0.222222rem;
    }
    .mobhome_tview{
        width: 100%;
        height: 100%;
        border-radius: 0.222222rem;

    }
    .mobhome_thrview{
        width: 100%;
        height: 0.916667rem;
        margin: 11px auto 0 auto;
    }
    .mobhome_thrview img{
        width: 43.47%;
        display: block;
        margin: 0 auto;
    }
    .mobhome_fivborder{
        width: 88.89%;
        padding-top: 1.916667rem;
        margin: 0 auto;
    }
    .mobfooter_wrap{
        width: 100%;
        height: auto;
        background: #0A0B0E;
        padding-top: 1.944444rem;
        padding-bottom: 1.944444rem;
    }
    .mobfooter_cont{
        width: 88.89%;
        height: auto;
        margin: 0 auto;
    }
    .mobfooter_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 600;
        color: #E8E8E9;
        line-height: 0.444444rem;
    }
    .mobfooter_list{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_items{
        width: 100%;
        height: 1.5rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
    }
    .mobfooter_ileft{
        width: auto;
        height: 1.5rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #E8E8E9;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .mobfooter_ileft_active{
        color: #39CA80;
    }
    .mobfooter_iright{
        width: 0.277778rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
    }
    .mobfooter_iright img{
        display: block;
        width: 100%;
        height: 0.416667rem;
    }
    .mobfooter_middle{
        width: 100%;
        height: auto;
        padding-top: 1.388889rem;
    }
    .mobfooter_mimg{
        width: 100%;
        padding-top: 0.611111rem;
    }
    .mobfooter_mimg img{
        display: block;
        width: 4.861111rem;
    }
    .mobfooter_down{
        width: 100%;
        padding-top: 1.388889rem;
    }
    .mobfooter_dlist{
        width: 100%;
        height: auto;
        padding-top: 0.333333rem;
    }
    .mobfooter_dlitem{
        width: 100%;
        height: auto;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #B6B8BF;
    }
    .mobhome_tview .eshoy_slider_cont{
        width: 100%;
        background: none;
    }
    .mobhome_tview .sliderbox_wrap{
        width: 87.5%;
        margin: 0 auto;
    }
    .mobhome_tview .sliderbox_left{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_middle{
        width: 66%;
    }
    .mobhome_tview .sliderbox_right{
        width: 16.3%;
        height: 1.194444rem;
        padding-top: 1px;
    }
    .mobhome_tview .sliderbox_cimg{
        width: 100%;
        height: 0.694444rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mobhome_tview .eshoy_gold_small{
        display: block;
        width: 24px;
        height: 14px;
    }
    .mobhome_tview .eshoy_gold_more{
        display: block;
        width: 24px;
        height: 21px;
    }
    .mobhome_tview .sliderbox_ctext{
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.37rem;
        margin-top: 2px;
        position: relative;
    }
    .sliderbox_ctext_view{
        width: auto;
        height: 0.5rem;
        position: absolute;
        left: -0.22rem;
        top: 0;
    }
    .mobhome_tview .sliderBox{
        width: 100%;
    }
    .mobhome_tview .loan-content-box{
        width: 100%;
        height: auto;
    }
    .mobhome_tview .moneybox{
        height: 1.138889rem;
        font-size: 1.0rem;
        padding-bottom: 0.527778rem
    }
    .mobhome_tview .moneybox span {
        font-size: 1.2rem;
    }
    .mobhome_tview .sliderBox{
        margin: 0.35rem auto 0 auto;
    }
    .mobhome_tview .el-slider__bar{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__runway{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__button-wrapper{
        width: 0.972222rem !important;
        height: 0.972222rem !important;
        top: -0.388889rem !important;
    }
    .mobhome_tview .sliderbox_wrap{
        height: 1.694444rem;
    }
    .mobhome_tview .eshoy_slider_btns{
        width: 7.722222rem;
        height: 1.111111rem;
        margin-top: 0.42rem;
        margin-bottom: 0.277778rem;
    }
    .mobhome_tview .eshoy_slider_btn_view{
        width: 7.722222rem;
        height: 1.111111rem;
    }

    .moneybox {
        font-size: 0.833333rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        text-align: center;
        padding-bottom: 74px;
    }

    .moneybox span {
        font-size: 1.0rem;
    }

    .sliderBox {
        width: 546px;
        height: auto;
        background: #E4EFEB;
        border-radius: 5px;
        margin: 24px auto 0 auto;
        position: relative;
    }

    .range {
        display: none;
        justify-content: space-between;
        margin-top: 35px;
    }

    .range p {
        font-size: 16px;
        color: #666;
        font-weight: 500;
    }

    .range p span {
        font-size: 18px;
    }
    .sliderbox_wrap{
        width: 762px;
        height: 86px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .sliderbox_left{
        width: 88px;
        height: 86px;
    }

    .sliderbox_right{
        width: 88px;
        height: 86px;
    }
    .sliderbox_cimg{
        width: 88px;
        height: 50px;
    }
    .sliderbox_ctext{
        width: 100%;
        height: 36px;
        font-size: 18px;
        font-family: MiSans-Regular, MiSans;
        font-weight: 500;
        color: #8C8480;
        line-height: 36px;
        text-align: center;
    }
    .sliderbox_ctext span{
        padding-left: 6px;
    }
    .eshoy_slider_btns{
        width: 378px;
        height: 72px;
        margin: 80px auto 0 auto;
        cursor: pointer;
        position: relative;
    }
    .eshoy_slider_btn_view{
        width: 378px;
        height: 72px;
    }
    .eshoy_slider_btns img{
        display: block;
        width: 100%;
    }
    .kychome_slider_title{
        width: 100%;
        height: 1.083333rem;
        font-size: 0.444444rem;
        font-weight: bold;
        color: #333333;
        line-height: 1.083333rem;
        text-align: center;
    }
    .kychome_slider_title_one{
        width: 100%;
        height: 0.805556rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.527778rem;
        text-align: center;
    }
    .kychome_slider_title_two{
        width: 100%;
        height: 1.0rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
        margin-top: 20px;
    }
    .menus_wrap{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .menus_head{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0 1.055556rem 0.694444rem;
    }
    .menus_head img{
        display: block;
        width: 1.388889rem;
        height: 1.388889rem;
    }
    .menus_footer{
        width: 100%;
        height: 2.2rem;
        background: #F6F6F6;
        border-radius: 0px 0px 0px 0.555556rem;
        position: absolute;
        left: 0;
        bottom: 0;
        box-sizing: border-box;
        padding: 0.555556rem 0 0 0.694444rem;
        display: flex;
        justify-content: flex-start;
    }
    .menus_ficon{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ficon img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_ftext{
        width: 1.388889rem;
        height: 0.555556rem;
        margin-left: 0.361111rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #666666;
        line-height: 0.555556rem;
    }
    .menus_list{
        width: 100%;
        height: auto;
    }
    .menus_items{
        width: 100%;
        height: 1.305556rem;
    }
    .menus_item{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        padding-left: 0.694444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .menus_iicon{
        width: 0.916667rem;
        height: 0.555556rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding-right: 0.361111rem;
    }
    .menus_iicon01{
        display: block;
        width: 0.555556rem;
        height: 0.5rem;
    }
    .menus_iicon02{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon03{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .menus_iicon04{
        display: block;
        width: 0.5rem;
        height: 0.555556rem;
    }
    .menus_itext{
        width: auto;
        height: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.555556rem;
    }
    .menus_cview{
        width: 100%;
        height: 1.861111rem;
    }
    .menus_items_active .menus_item{
        background: #19A95C;
    }
    .menus_items_active .menus_itext{
        color: #FFFFFF;
    }

    #firstloan_head .audithome_cont{
        width: 100%;
        height: 6.861111rem;
        position: relative;
    }
    #firstloan_head .audithome_cview{
        width: 100%;
        height: 14.555556rem;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #firstloan_head .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    #firstloan_head .auditpass_bgimg{
        display: block;
        width: 100%;
    }
    #firstloan_head .audithome_cont .auditpass_view{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 4.222222rem;
    }
    #firstloan_head .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    #firstloan_head .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    #firstloan_head .auditpass_solid_view{
        width: 100%;
        height: 0.388889rem;
        margin-top: 4.25rem;
        box-sizing: border-box;
        padding: 0 0.444444rem;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .auditpass_solid_middle{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #19A95C;
        line-height: 0.388889rem;
    }
    #firstloan_head .auditpass_solid_left{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_left img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_solid_right{
        width: 2.916667rem;
        height: 0.388889rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .auditpass_solid_right img{
        display: block;
        width: 100%;
        height: 1px;
    }
    #firstloan_head .auditpass_times{
        width: 100%;
        height: 0.833333rem;
        display: flex;
        align-items: center;
    }
    #firstloan_head .zpan_hthr_times{
        width: auto;
        height: 0.694444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    #firstloan_head .zpan_hthr_ditmes_day {
        width: auto;
        height: 0.694444rem;
        line-height: 0.694444rem;
        font-size: 12px;
        color: #333333;
        font-weight: bold;
        padding: 0 2px;
    }
    #firstloan_head .zpan_hthr_titmes{
        width: 0.694444rem;
        height: 0.694444rem;
        background: #ffffff;
        border-radius: 0.083333rem;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #BCDCCA;
    }
    #firstloan_head .zpan_hthr_titmes span{
        width: 100%;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #19A95C;
        text-align: center;
    }
    #firstloan_head .zpan_hthr_ditmes{
        width: 0.388889rem;
        height: 0.583333rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #firstloan_head .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 0 auto;
    }
    #firstloan_head{
        padding-bottom: 30px;
    }
    .audithome_tps_text{
        width: 11rem;
        color: #333333;
        font-size: 12px;
        line-height: 0.833333rem;
        text-align: center;
    }
    .firstloan_amount{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 20px 0.416667rem 0 0.416667rem;
    }
    .firstloan_amount_left{
        width: 60%;
        height: 2.277778rem;
    }
    .firstloan_amount_right{
        width: 40%;
        height: 2.277778rem;
    }
    .firstloan_amount_title{
        width: 100%;
        height: auto;
        font-size: 16px;
        color: #333333;
    }
    .firstloan_amount_days{
        height: 1.58rem;
        font-size: 28px;
        display: flex;
        align-items: center;
    }
    .firstloan_amount_days span{
        font-size: 32px;
        padding: 0 4px 0 0;
    }
    .confirmloan_cmview {
        width: 100%;
        height: auto;
    }
    .confirmloan_cmview .itoken_check_vitleft {
        color: #808080;
    }
    .confirmloan_cmitems {
        width: 100%;
        height: 1.277778rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_cmileft {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmiright {
        width: auto;
        height: auto;
        font-size: 14px;
        font-weight: 400;
        color: #303332;
    }
    .confirmloan_cmview .itoken_check_vitems {
        padding-top: 0.444444rem;
        padding-bottom: 0.444444rem;
    }
    .itoken_checkvi_scale-1px {
        position: relative;
        border: none;
    }
    .itoken_checkvi_scale-1px:after {
        content: '';
        position: absolute;
        bottom: 0;
        background: #dfdcdc;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    ..itoken_check_vitem {
        width: 100%;
        height: auto;
    }
    .itoken_check_vitop {
        width: 100%;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .itoken_check_vitleft {
        width: auto;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #1a1a1a;
    }
    .itoken_check_vitright {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 2px;
    }
    .itoken_check_vitrnums {
        width: auto;
        height: 14px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
    }
    .itoken_check_vitrnums span {
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
        padding-right: 4px;
    }
    .itoken_check_vitrarrow {
        width: 14px;
        height: 14px;
        margin-left: 4px;
    }
    .itoken_check_vitrarrow img {
        display: block;
        width: 100%;
    }
    .itoken_check_vitleft_coupon {
        width: auto;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .itoken_check_vitleft_coupon span {
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
    }
    .confirmloan_cmcontrato_wrap {
        width: 100%;
        height: auto;
        padding: 11px 0 49px 0;
    }
    .confirmloan_cmcontrato_cont {
        width: 100%;
        height: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft {
        width: auto;
        height: 24px;
        display: flex;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft img {
        display: block;
        width: 24px;
        height: 24px;
    }
    .itoken_check_vitems_details {
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-bottom: 1.333333rempx;
    }
    .itoken_check_vitems_detail {
        width: 100%;
        height: auto;
        background: #f4f5f4;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 7px 14px;
    }
    .confirmloan_msgitems {
        width: 100%;
        height: 0.75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_msgileft {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 400;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright {
        width: auto;
        height: 13px;
        font-size: 13px;
        font-weight: 500;
        color: #69706e;
        line-height: 13px;
    }
    .confirmloan_msgiright span {
        padding-left: 10px;
    }
    .confirmloan_msgiright .delete__line{
        text-decoration: line-through;
    }
    .firstloan_loantitle{
        width: 100%;
        height: auto;
        font-size: 18px;
        color: #333333;
        font-weight: bold;
    }
</style>

